import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { CustomerNotificationTemplate } from 'shared/types';

interface ICustomerDeleteDialogProps {
  customerDeleteDialogOpen: boolean;
  isLoading: boolean;
  typeRequest: CustomerNotificationTemplate;
  onClose: () => void;
  onDelete: () => void;
}

export function CustomerDeleteDialog({
  customerDeleteDialogOpen,
  isLoading,
  typeRequest,
  onClose,
  onDelete,
}: ICustomerDeleteDialogProps) {
  return (
    <Dialog open={customerDeleteDialogOpen} onClose={onClose} fullWidth={true} aria-labelledby='delete-dialog'>
      <DialogTitle id='delete-dialog-title'>{`Are you sure you want to 
      ${typeRequest === 'reject' ? 'restore' : typeRequest === 'approve' ? 'delete' : typeRequest}
       this customer?`}</DialogTitle>
      <DialogActions>
        {isLoading ? (
          <>Loading...</>
        ) : (
          <>
            <Button onClick={onClose} color='primary'>
              No
            </Button>
            <Button onClick={onDelete} color='primary'>
              Yes
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
